import { useQuery } from "@tanstack/react-query";
import { CompetitionStreamingApi, StreamingSettingsResponse } from "@devour/client";
import getConfig from "@/utils/getConfig";

async function fetchCompetitionStreaming(competitionId: string): Promise<StreamingSettingsResponse | null> {
    return new CompetitionStreamingApi(getConfig()).getCompetitionsCompetitionIdStreaming({ competitionId });
}

export function useGetCompetitionStreaming(competitionId: string | undefined) {
    return useQuery({
        queryKey: ["competition-streaming", competitionId],
        queryFn: () => fetchCompetitionStreaming(competitionId!),
        enabled: Boolean(competitionId),
        staleTime: 60 * 1000,
    });
}
